module.exports = __webpack_public_path__ + "static/media/indicator-orange-25-30.db51da52.png";